import React from "react";
import { FileType } from "ui/Scripts/source/models/enums";
import * as Styled from "./AttachmentIcon.styles";
import { SvgIcon } from "@mui/material";
import { SvgReportSmall } from "../../../shared/icons";

interface AttachmentIconProps {
  fileType: FileType;
  color?: string;
  strokeColor?: string;
  size?: "medium" | "large"
}

const getFileType = (fileType: FileType) => {
    switch (fileType) {
    case FileType.Excel:
        return "XLS";
    case FileType.Html:
        return "HTM";
    case FileType.Image:
        return "IMG";
    case FileType.Pdf:
        return "PDF";
    case FileType.PowerPoint:
        return "PPT";
    case FileType.Text:
        return "TXT";
    case FileType.Word:
        return "DOC";
    case FileType.Archive:
        return "ZIP";
    case FileType.Document:
        return "D";
    }
};

export const AttachmentIcon = ({
    fileType,
    color = "#e9f0fa",
    strokeColor = "#848688",
    size = "medium"
}: AttachmentIconProps) => (
    <Styled.Container>
        <SvgIcon fontSize={size}>
            <SvgReportSmall color={color} stroke={strokeColor} />
        </SvgIcon>
        <Styled.Label fileType={fileType} size={size}>{getFileType(fileType)}</Styled.Label>
    </Styled.Container>
);
